import React, { memo } from 'react';
import { ContactActivityResponse } from '@business/entities/contact';
import { Media } from 'reactstrap';
import { Formatter } from '@core/utils/formatter';

export interface TicketTimelineItemProps {
  item: ContactActivityResponse;
}

export const TicketTimelineItem = memo((props: TicketTimelineItemProps) => {
  const { item } = props;
  return (
    <Media>
      <div className="mr-3">
        <i className={'bx bx-support h4 text-primary'} />
      </div>
      <Media body>
        <div className="bg-light p-3">
          <div className="d-flex justify-content-between">
            <span className="text">
              <a href={`/support-tickets/detail/${item.id}`}>
                <strong>{item.contactName}</strong>
              </a>
            </span>
            <span className="text-primary d-flex">{Formatter.formatTime(item.createdAt, 'LLL')}</span>
          </div>
          <div className="d-flex justify-content-between">
            <span className="text-primary"></span>
          </div>
          <div>{item.email as any}</div>
        </div>
      </Media>
    </Media>
  );
});
